// LivestreamDetailOnlineFooterMobile.js
'use strict';
import { connect } from 'react-redux';
import withRouter from '../component/WithRouter.jsx';

import LivestreamDetailOnlineFooterMobile from '../component/LivestreamDetailOnlineFooterMobile.jsx';

import getOperationData from '../selector/getOperationData.js';
import getLiveStreamData from '../selector/getLiveStreamData.js';
import {
  getIsToyDeviceOnline,
  getLivestreamMode,
  getShouldUseOverlayCta,
  getIsMeExclusivePrivateOngoingInitiator,
} from '../selector/getLivestreamComputedData.js';
import getIsCoveredByEntryGate from '../selector/getIsCoveredByEntryGate.js';
import getMeData from '../selector/getMeData.js';
import getModalData from '../selector/getModalData.js';
import getRemoteConfigData from '../selector/getRemoteConfigData.js';
import getPrivateShowStatus from '../selector/getPrivateShowStatus.js';
import checkLivestreamChatPreflightAndOpenPanel from '../action/checkLivestreamChatPreflightAndOpenPanel.js';

import setLiveStreamPanel from '../action/setLiveStreamPanel.js';
import toggleModal from '../action/toggleModal.js';
import login from '../action/login.js';
import setPlayerData from '../action/setPlayerData.js';
import setShouldDisplayUnmuteHint from '../action/setShouldDisplayUnmuteHint.js';

import {
  PRESET_SD,
  ExclusivePrivateStatus,
  LivestreamMode,
  privateShowStatus as PrivateShowStatus,
} from '../resource/liveStreamConstants.js';

import {
  BLUROUT_PARAMETERS,
  FEATURE_LIVESTREAM_UNMUTE_HINT_ENABLED,
  LIVESTREAM_UNMUTE_HINT_DURATION_SECONDS,
  SUPER_CHAT_FEATURE_TOGGLE,
} from '../RemoteConfigKeys.js';

const ONGOING_PRIVATE_SHOW_STATUSES = [
  PrivateShowStatus.FUNDING,
  PrivateShowStatus.FUNDING_FINAL_CALL,
  PrivateShowStatus.CONSIDERING,
  PrivateShowStatus.PREPARING,
  PrivateShowStatus.PERFORMING,
];

const mapStateToProps = (state, { streamId }) => {
  const meId = getMeData(state, 'id');
  const streamStatus = getLiveStreamData(state, [streamId], 'status');
  const isAuthed = !!getMeData(state, 'id');
  const hasStreamToken = !!(
    getOperationData(
      state,
      ['liveStream', 'paid', streamId],
      'byteplusToken'
    ) ||
    getOperationData(state, ['liveStream', 'paid', streamId], 'streamToken')
  );

  const previewBlurManifest = getRemoteConfigData(
    state,
    BLUROUT_PARAMETERS
  )?.[2];
  const isStreamPreviewBlurEnabled = !!previewBlurManifest;
  const shouldDisplayBlurCountdown =
    isStreamPreviewBlurEnabled && streamStatus === PRESET_SD && !hasStreamToken;

  const exclusivePrivateStatus = getLiveStreamData(
    state,
    [streamId, 'exclusivePrivate'],
    'status'
  );
  const livestreamMode = getLivestreamMode(state, streamId);

  return {
    isAuthed,
    isStreamer: meId != null && meId === streamId,
    streamStatus,
    isChatPanelOpen: getOperationData(
      state,
      ['liveStream', 'panel'],
      'isChatPanelOpen'
    ),
    isGiftModalOpen:
      getModalData(state, 'LiveStreamGiftModal', 'status') === 'display',
    isKaraokeModalOpen:
      getModalData(state, 'LiveStreamKaraokeModal', 'status') === 'display',
    isSuperChatOpen: getOperationData(
      state,
      ['liveStream', 'panel'],
      'isSuperChatOpen'
    ),
    canSendSuperChat: getRemoteConfigData(state, SUPER_CHAT_FEATURE_TOGGLE),
    isTriggerPrivateModalOpen:
      getModalData(state, 'LiveStreamTriggerPrivateModal', 'status') ===
      'display',
    isLiveStreaming: getLiveStreamData(state, [streamId], 'isLiveStreaming'),
    streamPreviewBlurDuration: +getRemoteConfigData(
      state,
      BLUROUT_PARAMETERS
    )?.[1],
    shouldDisplayBlurCountdown,
    hasStreamToken,
    shouldUseLivestreamAlert: getOperationData(
      state,
      ['liveStream', 'chat', streamId],
      'shouldUseLivestreamAlert'
    ),
    privateShowStatus: getPrivateShowStatus(state, streamId),
    isKaraokeDeviceOnline: getIsToyDeviceOnline(state, streamId),
    isMuted: getOperationData(state, ['player'], 'isMuted'),
    isCoveredByEntryGate: getIsCoveredByEntryGate(state),
    isUnmuteHintEnabled: !!getRemoteConfigData(
      state,
      FEATURE_LIVESTREAM_UNMUTE_HINT_ENABLED
    ),
    shouldDisplayUnmuteHint: !!getOperationData(
      state,
      ['liveStream'],
      'shouldDisplayUnmuteHint'
    ),
    unmuteHintDurationSeconds: getRemoteConfigData(
      state,
      LIVESTREAM_UNMUTE_HINT_DURATION_SECONDS
    ),
    isExclusivePrivateOngoing: [
      ExclusivePrivateStatus.PERFORMING,
      ExclusivePrivateStatus.PREPARING,
    ].includes(exclusivePrivateStatus),
    isOneOnOne: livestreamMode === LivestreamMode.ONE_VS_ONE,
    isPrivateShow: ONGOING_PRIVATE_SHOW_STATUSES.includes(
      getPrivateShowStatus(state, streamId)
    ),
    isExclusivePrivatePerforming:
      exclusivePrivateStatus === ExclusivePrivateStatus.PERFORMING,
    isMeExclusivePrivateOngoingInitiator:
      getIsMeExclusivePrivateOngoingInitiator(state, streamId),
    shouldUseOverlayCta: getShouldUseOverlayCta(state, streamId),
  };
};

const mapDispatchToProps = dispatch => {
  return {
    login: () => dispatch(login()),
    setChatPanel: ({ isChatPanelOpen }) =>
      dispatch(setLiveStreamPanel({ isChatPanelOpen })),
    toggleModal: data => dispatch(toggleModal(data)),
    checkLivestreamChatPreflightAndOpenPanel: data =>
      dispatch(checkLivestreamChatPreflightAndOpenPanel(data)),
    setMuted: data => dispatch(setPlayerData(data)),
    markUnmuteHintSeen: () =>
      dispatch(setShouldDisplayUnmuteHint({ shouldDisplayUnmuteHint: false })),
  };
};

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(LivestreamDetailOnlineFooterMobile)
);
